/**
 * LoadMore
 * Append-based pagination: "Load More" button with a progress bar.
 */

import styled from '@emotion/styled';

export const LoadMoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space.lg};
`;

export const LoadMoreButton = styled.button<{ $disabled?: boolean }>`
  padding: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.xl};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.demi};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 2px solid ${({ theme }) => theme.colors.text.primary};
  border-radius: ${({ theme }) => theme.radius.small};
  background: transparent;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  transition: background 0.2s, color 0.2s;

  &:hover:not([disabled]) {
    background: ${({ theme }) => theme.colors.text.primary};
    color: ${({ theme }) => theme.colors.background.primary};
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm};
  width: 100%;
  max-width: 300px;
`;

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 4px;
  background: ${({ theme }) => theme.colors.border.color};
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  background: ${({ theme }) => theme.colors.pallete.primary.color};
  border-radius: 2px;
  transition: width 0.3s ease;
`;

export const ProgressText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
